export function userHasRequiredGroups(userGroups, requiredGroups) {
  if (requiredGroups.length === 0) {
    return true;
  }
  return requiredGroups.some(group => userGroups.findIndex(p => p === group) !== -1);
}